import { Button, WrapPage, Toast } from 'common/ui'
import { useDioxContext } from 'common/hooks'
import { useCallback } from 'react'
import styled from 'styled-components'
import { getDefaultToken } from 'common/utils'

const HomeStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #ffffff;
  width: 720px;
  height: 361px;
  position: absolute;
  top: 200px;
  left: 50%;
  transform: translateX(-50%);
  .border-y {
    position: absolute;
    border-width: 1px;
    border-style: solid;
    border-image: linear-gradient(to bottom, transparent, #d7ba80, transparent)
      1;
    width: 100%;
    height: 100%;
    top: -0.5px;
    left: -0.5px;
    z-index: -1;
  }
  .border-x {
    position: absolute;
    border-width: 1px;
    border-style: solid;
    border-image: linear-gradient(
        to left,
        transparent 2%,
        #d7ba80,
        transparent 98%
      )
      1;
    width: 100%;
    height: 100%;
    top: -0.5px;
    left: -0.5px;
    z-index: -1;
  }
  h2 {
    margin-bottom: 25px;
    margin-top: 84px;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
  }
  .desc {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 26px;
    color: #a3a3a3;
  }
  button {
    width: 164px;
    margin-top: 54px;
  }
`

const Home = () => {
  const { dioxide } = useDioxContext()
  const defaultToken = getDefaultToken()

  const handleFaucet = useCallback(async () => {
    if (dioxide) {
      try {
        const r = await dioxide.request({
          method: 'send_transaction',
          params: {
            func: 'core.coin.faucet',
          },
        })
        Toast({ text: 'Success' })
      } catch (e: any) {
        Toast({ text: e?.message })
      }
    }
  }, [dioxide])
  return (
    <HomeStyled>
      <div className="border-y"></div>
      <div className="border-x"></div>
      <h2>TestNet Faucet</h2>
      <p className="desc">
        Click the Faucet button to get 100 {defaultToken.SYMBOL}
      </p>
      <Button type="primary" size="large" onClick={handleFaucet}>
        Faucet
      </Button>
    </HomeStyled>
  )
}
export default WrapPage(Home, {
  title: 'TestNet Faucet',
  logo: '/img/logo.png',
  bg: '/img/bg.png',
})
